<template>

  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{_.startCase(currentProfile)}}
          </h3>
        </div>
        <div class="col-md-9 text-right">
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
        
        <div>
            <h6 class="heading-small text-muted mb-4">Z-READING PREVIEW</h6>
            <div v-if="this.zread_data != null" style="font-family: Palatino Linotype">
              <div v-if="this.zread_data.pos_version == '5.1'">
                <table width="100%">
                    <tr>
                        <td align="left">Terminal:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td align="right">{{zread_data.terminal}}</td>
                    </tr>
                    <tr>
                        <td align="left">Printed by:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td align="right">{{zread_data.printedBy}}</td>
                    </tr>
                    <tr>
                        <td colspan="4">&nbsp;</td>
                    </tr>
                    <tr>
                        <td align="left">Start Date & Time:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td align="right">{{this.zread_data.dateFrom}}</td>
                    </tr>
                    <tr>
                        <td align="left">End Date & Time:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td align="right">{{this.zread_data.dateTo}}</td>
                    </tr>
                    <tr>
                        <td align="left">Business Date:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td align="right">{{this.zread_data.businessDate}}</td>
                    </tr>
                    <tr>
                        <td colspan="4">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="4">&nbsp;</td>
                    </tr>
                    <tr>
                        <td align="left">BEGINNING SI</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.beginningSi).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">ENDING SI</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.endingSi).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">BEGINNING VS</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.beginningVS).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">ENDING VS</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.endingVS).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">BEGINNING RS</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.beginningRS).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">ENDING RS</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.endingRS).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">BEGINNING RF</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.beginningRF).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">ENDING RF</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.endingRF).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">BEGINNING Trans</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.firstTransactionId).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">ENDING Trans</td>
                        <td>#:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.lastTransactionId).padStart(9, '0')}}</td>
                    </tr>
                    <tr>
                        <td align="left">Transaction Count</td>
                        <td>&nbsp;&nbsp;:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.totalTransactionCount).padStart(9, '0')}}</td>
                    </tr>
                </table>
                <br/>
                <table width="100%">
                    <tr>
                        <td align="left">Reset Counter No.</td>
                        <td>&nbsp;</td>
                        <td align="right">{{this.zread_data.resetCounterSI}}</td>
                    </tr>
                    <tr>
                        <td align="left">Z Counter No. :</td>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.zReadingCounter).padStart(5, '0')}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <td align="left">Present Accum Sales:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.endingGrossBalance).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Previous Accum Sales:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.beginningGrossBalance).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Sales for the Day:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <td align="left">MANUAL/REPLACED SI:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber((parseFloat(this.zread_data.deductions.manual) + parseFloat(this.zread_data.adjustmentsOnVat.manual)).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">&nbsp;</td>
                    </tr>
                    <tr>
                        <th colspan="3" style="text-align: center">BREAK DOWN OF SALES</th>
                    </tr>
                    <tr>
                        <td align="left">VATABLE&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.vatable).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">VAT AMOUNT:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.vatAmount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">VAT-EXEMPT&nbsp;:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.vatExempt).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">ZERO-RATED&nbsp;:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.zeroRated).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <td align="left">Gross Amount:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Less Discount:</td>
                        <td>&nbsp;</td>
                        <td align="right">
                          {{formatNumber(parseFloat(
                            this.zread_data.deductions.total - 
                            this.zread_data.deductions.returns - 
                            this.zread_data.deductions.void - 
                            this.zread_data.deductions.refund)
                          .toFixed(2))}}
                        </td>
                    </tr>
                    <tr>
                        <td align="left">Less Return:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.returns).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Less Refund:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.refund).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Less Void:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Less Vat Adjustment:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Net Amount:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSales).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th colspan="3" style="text-align: center">DISCOUNT SUMMARY</th>
                    </tr>
                    <tr>
                        <td align="left">SC 5% Disc.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.SCDiscount5).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">SC 20% Disc.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.SCDiscount20).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">PWD 5% Disc.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.PWDDiscount5).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">PWD 20% Disc.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.PWDDiscount20).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">NAAC Disc.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.naacSPDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">SOLO P. Disc.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.specialTenPercentDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">MOV Disc.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.movSPDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Other Disc.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.regular).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th colspan="3" style="text-align: center">SALES ADJUSTMENT</th>
                    </tr>
                    <tr>
                        <td align="left">Return:</td>
                        <td align="right">{{ this.zread_data.deductions.returnsCount }}</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.returns).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Refund:</td>
                        <td align="right">{{ this.zread_data.deductions.refundCount }}</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.refund).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Void:</td>
                        <td align="right">{{ this.zread_data.deductions.voidCount }}</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th colspan="3" style="text-align: center">VAT ADJUSTMENT</th>
                    </tr>
                    <tr>
                        <td align="left">SC Trans.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.SCDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">PWD Trans.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.PWDDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">SOLO P. Trans.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.specialTenPercentDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">Regular Disc Trans.:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.regular).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">VAT on Return:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.returns).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">VAT on Refund: </td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.refund).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">VAT on Void:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th colspan="3" style="text-align: center">NET VAT BREAKDOWN</th>
                    </tr>
                    <tr>
                        <td align="left">VATABLE:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSalesBreakdown.vatable).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">VAT AMOUNT PAYABLE:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSalesBreakdown.vatAmount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">VAT-EXEMPT:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSalesBreakdown.vatExempt).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td align="left">ZERO-RATED:</td>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSalesBreakdown.zeroRated).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th colspan="3" style="text-align: center">TRANSACTION SUMMARY</th>
                    </tr>
                    <tr>
                        <th align="left">Amount In Drawer:</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.amountInDrawer.payments).toFixed(2))}}</td>
                    </tr>
                    <!-- ADD PAYMENT BREAKDOWN HERE -->
                    <tr v-for="payment in paymentTypes" :key="payment.id">
                        <td style="padding-left: 5%;">{{payment.name}}</td>
                        <td align="right">{{ getPaymentSummaryValue(`${payment.code}Count`) }}</td>
                        <td align="right" v-if="_.isNaN(parseFloat(getPaymentSummaryValue(payment.code)))" >0.00</td>
                        <td align="right" v-else >{{formatNumber(parseFloat(getPaymentSummaryValue(payment.code)).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th align="left">Opening Fund:</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.amountInDrawer.deposit).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th align="left">Less Withdrawal:</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.amountInDrawer.withdrawal).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th align="left">Payments Received:</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.amountInDrawer.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">&nbsp;</td>
                    </tr>
                    <tr>
                        <th align="left">OTHER INCOME</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.otherIncome.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th align="left">EXCESS GC</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.otherIncome.excessGC).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th align="left">EXCESS RS</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.otherIncome.excessRS).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th align="left">SHORT/OVER:</th>
                        <td>&nbsp;</td>
                        <td align="right">
                          {{formatNumber(parseFloat(
                            this.zread_data.amountInDrawer.withdrawal - 
                            this.zread_data.amountInDrawer.deposit - 
                            this.zread_data.amountInDrawer.payments
                          ).toFixed(2))}}</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <th colspan="3" style="text-align: center">COLLECTIONS</th>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <td colspan="3">&nbsp;</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <th align="left">BEGINNING AR:</th>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.beginningAR).padStart(9, '0')}}</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <th align="left">ENDING AR:</th>
                        <td>&nbsp;</td>
                        <td align="right">{{String(this.zread_data.endingAR).padStart(9, '0')}}</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <th align="left">AR COUNT:</th>
                        <td>&nbsp;</td>
                        <td align="right">{{this.zread_data.countAR}}</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <td colspan="3">&nbsp;</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <th align="left">GIFT CERT SELLING:</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.gc_selling_amount).toFixed(2))}}</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <td colspan="3">&nbsp;</td>
                    </tr>
                    <tr v-if="isEnabledGcSelling">
                        <th align="left">PAYMENT SUMMARY</th>
                        <td>&nbsp;</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.gc_selling_amount).toFixed(2))}}</td>
                    </tr>
                    <!-- ADD PAYMENT BREAKDOWN HERE -->
                    <tr  v-if="isEnabledGcSelling" v-for="payment in paymentTypesColl" :key="'collection-' + payment.id">
                        <td style="padding-left: 5%;">{{payment.name}}</td>
                        <td align="right">{{ getPaymentSummaryCollectionValue(`${payment.code}Count`) }}</td>
                        <td align="right" v-if="_.isNaN(parseFloat(getPaymentSummaryCollectionValue(payment.code)))" >0.00</td>
                        <td align="right" v-else >{{formatNumber(parseFloat(getPaymentSummaryCollectionValue(payment.code)).toFixed(2))}}</td>
                    </tr>
                </table>
              </div>
              <div v-else>
                <br>
                Z Reading : {{this.zread_data.zReadingCounter}} <br>
                Terminal  : {{zread_data.terminal}} <br>
                Printed by  : {{zread_data.printedBy}} <br>
                Date    : {{this.zread_data.businessDate}} <br><br>
                <table width="100%">
                    <tr>
                        <th>GROSS SALES</th>
                        <td align="right">{{this.zread_data.grossSales.count}}</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VATABLE SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.vatable).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT AMOUNT</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.vatAmount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT-EXEMPT SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.vatExempt).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">ZERO-RATED SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.grossSales.zeroRated).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>DEDUCTIONS</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">REG DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.regular).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SP 5% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.specialVatableDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SP 20% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.specialVatExemptDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">RETURNS</td>
                        <td align="right">{{this.zread_data.deductions.returnsCount}}</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.returns).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VOID</td>
                        <td align="right">{{this.zread_data.deductions.voidCount}}</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">MANUAL</td>
                        <td align="right">{{this.zread_data.deductions.manualCount}}</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.deductions.manual).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>VAT ADJUSTMENTS</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">REG DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.regular).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SP 5% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.specialVatableDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SP 20% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.specialVatExemptDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">RETURNS</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.returns).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VOID</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">MANUAL</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.adjustmentsOnVat.manual).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>NET SALES</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSales).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>NET VAT AMOUNT</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netVatAmount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>TOTAL QUANTITY</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.totalQuantity).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>OTHER INCOME</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.otherIncome.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">EXCESS GC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.otherIncome.excessGC).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">EXCESS RS</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.otherIncome.excessRS).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>AMOUNT IN DRAWER</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.amountInDrawer.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">+ DEPOSIT</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.amountInDrawer.deposit).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">+ PAYMENTS</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.amountInDrawer.payments).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">- WITHDRAWAL</td>
                        <td align="right"></td>
                        <td align="right">({{formatNumber(parseFloat(this.zread_data.amountInDrawer.withdrawal).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <th>PAYMENT SUMMARY</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.paymentSummary.total).toFixed(2))}}</td>
                    </tr>
                    <!-- ADD PAYMENT BREAKDOWN HERE -->

                    <tr v-for="payment in paymentTypes" :key="payment.id">
                        <td style="padding-left: 5%;">{{payment.name}}</td>
                        <td align="right">{{ getPaymentSummaryValue(`${payment.code}Count`) }}</td>
                        <td align="right" v-if="_.isNaN(parseFloat(getPaymentSummaryValue(payment.code)))" >0.00</td>
                        <td align="right" v-else >{{formatNumber(parseFloat(getPaymentSummaryValue(payment.code)).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td>TRANS RESET COUNT</td>
                        <td align="right"></td>
                        <td align="right">{{this.zread_data.transResetCount}}</td>
                    </tr>
                    <tr>
                        <td>SI RESET COUNT</td>
                        <td align="right"></td>
                        <td align="right">{{this.zread_data.siResetCount}}</td>
                    </tr>
                    <tr>
                        <td>BEGINNING SI</td>
                        <td align="right">:</td>
                        <td align="right">{{this.zread_data.beginningSi}}</td>
                    </tr>
                    <tr>
                        <td>ENDING SI</td>
                        <td align="right">:</td>
                        <td align="right">{{this.zread_data.endingSi}}</td>
                    </tr>
                    <tr>
                        <td>SI COUNT</td>
                        <td align="right">:</td>
                        <td align="right">{{this.zread_data.siCount}}</td>
                    </tr>
                    <tr>
                        <td>BEGINNING BALANCE</td>
                        <td align="right">:</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.beginningBalance).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td>ENDING BALANCE</td>
                        <td align="right">:</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.endingBalance).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td>NET SALES</td>
                        <td align="right">:</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSales).toFixed(2))}}</td>
                    </tr>


                    <tr>
                        <td>FIRST TRANSACTION</td>
                        <td align="right">:</td>
                        <td align="right">{{this.zread_data.firstTransactionId}}</td>
                    </tr>

                    <tr>
                        <td>LAST TRANSACTION</td>
                        <td align="right">:</td>
                        <td align="right">{{this.zread_data.lastTransactionId}}</td>
                    </tr>

                    <tr>
                        <td>TRANSACTION COUNT</td>
                        <td align="right">:</td>
                        <td align="right">{{this.zread_data.totalTransactionCount}}</td>
                    </tr>

                    <tr>
                        <th>NET VAT BREAKDOWN</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>

                    <tr>
                        <td style="padding-left: 5%;">VATABLE SALES</td>
                        <td align="right">:</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSalesBreakdown.vatable).toFixed(2))}}</td>
                    </tr>

                    <tr>
                        <td style="padding-left: 5%;">VAT-EXEMPT SALES</td>
                        <td align="right">:</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSalesBreakdown.vatExempt).toFixed(2))}}</td>
                    </tr>

                    <tr>
                        <td style="padding-left: 5%;">ZERO-RATED SALES</td>
                        <td align="right">:</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSalesBreakdown.zeroRated).toFixed(2))}}</td>
                    </tr>

                    <tr>
                        <td style="padding-left: 5%;">VAT AMOUNT</td>
                        <td align="right">:</td>
                        <td align="right">{{formatNumber(parseFloat(this.zread_data.netSalesBreakdown.vatAmount).toFixed(2))}}</td>
                    </tr>

                </table>
              </div>
            </div>
        </div>
    </a-drawer>
   
    <div class="table-responsive" >
        <vuetable  ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
        @vuetable:load-error="onLoadError" 
        @vuetable:pagination-data="onPaginationData">

        <template slot="actions" slot-scope="props">
          <center>
            <button class="btn btn-success btn-sm" @click.prevent="showDetails(props.rowData.reading_details,props.rowData.is_enabled_gc_selling)">View Details</button>&nbsp;&nbsp;
          </center>
        </template>

      </vuetable>
    </div>
    
    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>

  import axios from "axios";
  import {
    mapState
  } from 'vuex'

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';

  var component_x;

  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
      Vuetable,
      VuetablePagination
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType'])
    },
    data() {
      return {
        paymentTypes: [],
        paymentTypesColl: [],
        tableType: "z_reading",
        zread_data: null,
        drawerVisible: false,
        filterStatus: "",
        profileAction: "",
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        visible: false,
        availableFields: [],
        apiURL: "",
        fields: [{name: "site_name", title: "Site"}, 
                  {name: "terminal_name", title: "Terminal"}, 
                  {name : "business_date", title: "Business Date"},
                  '__slot:actions'],
        sortOrder: [{
          field: "business_date",
          direction: "desc"
        }],
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
          }
        },
        css: {
          table: {
            tableClass: 'table table-sm table-striped table-bordered table-hovered',
            loadingClass: 'loading'
          },
          pagination: {
            infoClass: 'pull-right',
            wrapperClass: 'vuetable-pagination pull-right',
            activeClass: 'btn-primary btn-sm',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          }
        },
        isEnabledGcSelling:false
      }
    },
    watch: {
      currentApiURL: function () {
        this.apiURL = this.currentApiURL
        // console.log(this.currentApiURL.includes("x_readings"))
      },
      parameters: function () {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []		
        this.checkedItems = []
      }
    },
    methods: {
      getPaymentSummaryValue(key) {
        if (!this.zread_data || !this.zread_data.paymentSummary) return 0;

        const targetKey = key.toLowerCase();
        const summary = this.zread_data.paymentSummary;

        for (const k in summary) {
          if (k.toLowerCase() === targetKey) {
            return summary[k];
          }
        }

        return 0; // default if key not found
      },
      getPaymentSummaryCollectionValue(key) {
        if (!this.zread_data) return 0;
        let targetKeyCol = key.toLowerCase();
        if(this.zread_data.paymentSummaryCollection != null){
            if (!this.zread_data.paymentSummaryCollection.PaymentDetails) return 0;
            let summaryCol = this.zread_data.paymentSummaryCollection.PaymentDetails;
            for (let k1 in summaryCol) {
                if (k1.toLowerCase() === targetKeyCol) {
                    return summaryCol[k1];
                }
            }
        }
        return 0; // default if key not found
      },
      formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      showDetails(zread,is_enabled_gc_selling){  
        this.drawerVisible = true;
        //   this.zread_data = JSON.parse(zread);
        this.isEnabledGcSelling = is_enabled_gc_selling
        this.zread_data = zread;
      },
      onClose(){
          this.drawerVisible = false
      },
      refreshPage() {
        this.onClose()
        this.$refs.vuetable.refresh()
        this.successMessage = "Successful Operation"
        this.errorMessage = null
      },
      removeMessage(type) {
        if (type == 'error')
          this.errorMessage = null
        else
          this.successMessage = null
      },
      async onPaginationData(paginationData) {
        // await axios({
        //     method: 'PUT',
        //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
        //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
        // })
        this.$refs.pagination.setPaginationData(paginationData);
      },
      async onLoadError(error) {
        // request for new token or reauthenticate
        if (error.response.status == 401) {
          var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
          if (auth_response["status"] == "Ok") {
            this.$router.go();
          } else {
            alert("Cannot get access token. Please login again.")
            this.$router.push("/")
          }
        } else {
          if(error.response.data.error == "Session expired"){
              alert("Session is already expired. Please login again.")
              document.getElementById("logoutButton").click()
          } else if(error.response.data.error == "Invalid IP for Access Token"){
            alert("Invalid Access Token. Please login again.")
            document.getElementById("logoutButton").click()
          }
        }
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      }
    },
    mounted: async function () {
      component_x = this;
      this.apiURL = this.currentApiURL + this.parameters
      if(this.apiURL.includes("x_reading") == true){
          this.tableType = "x_reading"
      }
      // payment types
      this.paymentTypes = await HTTPRequest.getRequest(this.endPoint + 'payment_types/get_valid_payment_types', null)
      this.paymentTypesColl = this.paymentTypes
      console.log(this.$refs.vuetable)
      this.$refs.vuetable.normalizeFields()
      this.$refs.vuetable.refresh()
    }
  }
</script>

<style>
</style>